import { palette } from "../../palette";
// Assuming theme is defined using palette function from "../../palette"
const theme = palette("light");
export function list(theme) {
    return {
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                    "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: theme.palette.primary.lighter,
                        color: theme.palette.primary.dark,
                        // boxShadow: "0px 8px 16px 0px #9E00243D",
                        borderRadius: "8px",
                        fontWeight: 600,
                    },
                    "&:hover": {
                        // color: theme.palette.common.white,
                        // backgroundColor: theme.palette.primary.light,
                        borderRadius: "8px",
                    },
                },
            },
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    marginRight: 0,
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "40px",
                    marginRight: 0,
                    color: "inherit",
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    margin: 0,
                },
                multiline: {
                    margin: 0,
                    fontSize: "14px",
                },
            },
        },
    };
}
